import "./AboutSupport.module.css";
import Header from "@/reusable_sections/Header";
import UnderstandingPda from "./sections/UnderstandingPda";
import TheDiagnosticProcess from "./sections/TheDiagnosticProcess";
import Footer from "@/reusable_sections/Footer";
export default function AboutSupportPage() {
  return <div>
      <Header />
      <UnderstandingPda />
      <TheDiagnosticProcess />
      <Footer />
    </div>;
}